<script setup>
import { useI18n } from 'vue-i18n';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
  conversation: {
    type: Object,
    default: () => ({}),
  },
  item: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['quick-action']);

const { t } = useI18n();

const quickActions = [
  { id: 'move', icon: 'arrow-right', color: 'emerald', description: t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.MOVE') },
  { id: 'assign', icon: 'person', color: 'violet', description: t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.ASSIGN') },
  { id: 'chat', icon: 'chat', color: 'amber', description: t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.CHAT') },
  { id: 'duplicate', icon: 'copy', color: 'sky', description: t('KANBAN.QUICK_ACTIONS_DESCRIPTIONS.DUPLICATE') },
];

const handleActionClick = (actionId) => {
  emit('quick-action', {
    actionId,
    contact: props.contact,
    conversation: props.conversation,
    item: props.item,
  });
};
</script>

<template>
  <div class="quick-actions bg-white dark:bg-slate-800 rounded-lg p-4 border border-slate-200 dark:border-slate-700">
    <h3 class="text-sm font-medium text-slate-900 dark:text-slate-100 mb-3">
      {{ t('KANBAN.QUICK_ACTIONS') }}
    </h3>
    <div class="grid grid-cols-4 gap-2">
      <button
        v-for="action in quickActions"
        :key="action.id"
        class="quick-action-btn flex flex-col items-center"
        :class="{
          'hover:bg-emerald-50 dark:hover:bg-emerald-900/20 hover:text-emerald-600 dark:hover:text-emerald-400':
            action.color === 'emerald',
          'hover:bg-violet-50 dark:hover:bg-violet-900/20 hover:text-violet-600 dark:hover:text-violet-400':
            action.color === 'violet',
          'hover:bg-amber-50 dark:hover:bg-amber-900/20 hover:text-amber-600 dark:hover:text-amber-400':
            action.color === 'amber',
          'hover:bg-sky-50 dark:hover:bg-sky-900/20 hover:text-sky-600 dark:hover:text-sky-400':
            action.color === 'sky',
        }"
        @click="handleActionClick(action.id)"
      >
        <fluent-icon
          :icon="action.icon"
          size="20"
          :class="{
            'text-emerald-500 dark:text-emerald-400':
              action.color === 'emerald',
            'text-violet-500 dark:text-violet-400':
              action.color === 'violet',
            'text-amber-500 dark:text-amber-400': action.color === 'amber',
            'text-sky-500 dark:text-sky-400': action.color === 'sky',
          }"
        />
        <span class="text-xs mt-1 text-slate-600 dark:text-slate-400">{{ action.description }}</span>
      </button>
    </div>
  </div>
</template>

<style scoped>
.quick-action-btn {
  @apply flex items-center justify-center p-3 rounded-xl transition-all duration-200 bg-slate-50 dark:bg-slate-800/50;
}

.quick-action-btn:hover {
  @apply transform -translate-y-0.5 shadow-lg;
}

.quick-action-btn:active {
  @apply transform translate-y-0 shadow-md;
}
</style> 